import type { UserConsent } from './types'

export const cookieNames = {
  // Anonymous UUID used for segment
  anonymous_id: 'ajs_anonymous_id',
  // UUID used for split.io
  browser_id: '_gs_browser_id',
  // Coupon code. Needs to be passed on to the WBF and later to the backend.
  coupon: '_gs-coupon',
  // Validated coupon discount amount (in cents). Persisted alongside `coupon`
  // so the applied discount survives a page refresh in the buying flow.
  couponAmount: '_gs-coupon-amount',
  // Deterimines the campaign which should be show in the WBF. Needs to be passed on to the WBF
  campaign: '_gs-campaign',

  // Contains the name of the referring person
  referrerName: '_gs-referrerName',

  // Referral code, needs to be passed on to the WBF
  referralCode: '_gs-referralToken',

  // Code which is used by financeAds to track conversions. Needs to be passed on to the WBF.
  fa_tracking_parameter: '_gs-conv-fa',

  // Code which is used by awin to track conversions. Needs to be passed on to the WBF.
  aw_tracking_parameter: '_gs-conv-aw',

  // Code which is used for generic conversion tracking. Needs to be passed on to the WBF.
  utm_source: '_gs-conversion-source-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_campaign: '_gs-conversion-campaign-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_medium: '_gs-conversion-medium-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_term: '_gs-conversion-term-parameter',

  // Utm parameter which may be sent by a partner. It can be used in WBF tracking events
  utm_content: '_gs-conversion-content-parameter',

  // Click ID used by XPerty affiliate partner for purchase attribution
  clickid: '_gs-conv-clickid',

  // Google Click ID used for Google Ads conversion tracking
  gclid: '_gs-conv-gclid',

  // Advertiser ID used by Addrevenue affiliate partner for purchase attribution
  advertiserId: '_gs-conv-advertiser-id',

  // Channel ID used by Addrevenue affiliate partner for purchase attribution
  channelId: '_gs-conv-channel-id',

  // Click reference used by the ChatGPT Ad Network for conversion attribution
  oppref: '_gs-conv-oppref',

  // Click ID used by Impact (impact.com) for purchase attribution
  ir_clickid: '_gs-conv-irclickid',
} as const

export const COOKIES_CATEGORIES: Record<string, string[]> = {
  necessary_cookies: [
    cookieNames.referrerName,
    cookieNames.referralCode,
    cookieNames.coupon,
    cookieNames.couponAmount,
    cookieNames.anonymous_id,
    cookieNames.browser_id,
    cookieNames.campaign,
    cookieNames.fa_tracking_parameter,
    cookieNames.clickid,
    cookieNames.gclid,
    cookieNames.advertiserId,
    cookieNames.channelId,
    cookieNames.oppref,
    cookieNames.ir_clickid,
  ],
  functional_cookies: [],
  advertising_cookies: [
    cookieNames.aw_tracking_parameter,
    cookieNames.utm_campaign,
    cookieNames.utm_source,
    cookieNames.utm_medium,
  ],
}

export const getAllowedCookies = (userConsent: UserConsent) => {
  const cookieConsent = Object.keys(COOKIES_CATEGORIES).reduce((acc, cookie) => {
    acc[cookie] = userConsent[cookie]
    return acc
  }, {} as UserConsent)

  const allowedCookies = Object.keys(cookieConsent).reduce((acc, key) => {
    acc.push(...COOKIES_CATEGORIES[key])
    return acc
  }, [] as string[])

  return allowedCookies
}

export const isCookieNecessary = (cookieName: string) =>
  COOKIES_CATEGORIES.necessary_cookies.indexOf(cookieName) !== -1
